import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CpGenericControl, CpGridDefaultGroupsControl, CpImportControl } from '../../cp-configuration/view-model';

@Component({
    selector: 'cp-additional-content',
    templateUrl: './additional-content.component.html',
    styleUrls: ['./additional-content.component.scss'],
    standalone: false
})
export class CpAdditionalContentComponent {
    @Input() control!: CpImportControl | CpGenericControl | CpGridDefaultGroupsControl;

    @Input() cardId!: string;

    @Input() disabled!: boolean;

    @Output() edited = new EventEmitter<void>();

    get genericControl() {
        return this.control as CpGenericControl;
    }

    get importControl() {
        return this.control as CpImportControl;
    }

    get gridDefaultGroupsControl() {
        return this.control as CpGridDefaultGroupsControl;
    }

    _onEdited() {
        this.edited.emit();
    }
}
